import request from '@/utils/request';
export const defaultTransporterData = {
  id: 0,
  enabled: true,
  name: undefined,
  mobileNumber: undefined,
  gstNumber: undefined,
  vehicleNumber: undefined,
  freightPerCarton: 0,
  countryId: null,
  line1: null,
  line2: null,
  pincodeId: null,
  country: {
    id: null
  },
  stateId: null,
  bookingStateId: null,
  cityId: null,
  addressCityId: null,
  city: {
    id: null
  },
  branchId: null,
  branch: {
    id: null
  }
};
export const getTransporters = params => request({
  url: '/transporters',
  method: 'get',
  params
});
export const createTransporter = data => request({
  url: '/transporters',
  method: 'post',
  data
});
export const getTransporterById = id => request({
  url: `/transporters/${id}`,
  method: 'get'
});
export const updateTransporter = (id, data) => request({
  url: `/transporters/${id}`,
  method: 'patch',
  data
});
export const downloadExcel = data => request({
  url: '/transporters/download-excel',
  method: 'post',
  data,
  responseType: 'blob'
});
export const deleteTransporter = id => request({
  url: `/transporters/${id}`,
  method: 'delete'
});